let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("coSlg")).then(() => parcelRequire('7CKM8'));